import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    register: {
      header: 'Register',
      alreadyHaveAnAccount: 'Already have an account ?',
      login: 'Log in',
      info: {
        description:
          'By creating an account you allow us to store the below data in our database. You can remove your account at anytime.',
      },
      email: {
        info: 'We need your email for identification purpose.',
      },
      password: {
        info: 'Your password will be securily encypted before storing in the database.',
      },
    },
    login: {
      header: 'Log in',
      forgotPassword: 'Forgot my password',
    },
    recover: {
      header: 'Password recovery',
    },
  },
}
